import React from 'react';
import { Check, X, Loader2 } from 'lucide-react';

const PhotoPriceModal = ({ 
  show, 
  onClose, 
  onUpdate, 
  currentPrice, 
  onPriceChange, 
  loading 
}) => {
  if (!show) return null;

  const handlePriceInput = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    onPriceChange(value === "" ? 0 : parseInt(value, 10));
  };

  const handleKeyDown = (e) => {
    // Prevent entering non-digit characters
    if (
      !/\d/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    }
  };

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <h2>Update Photo Price</h2>
        {loading ? (
          <div className="center">
            <Loader2 className="spin" size={32} />
          </div>
        ) : (
          <div className="field">
            <label>Price ($)</label>
            <input
              type="text"
              value={currentPrice}
              onChange={handlePriceInput}
              onKeyDown={handleKeyDown}
              className="price-input"
              inputMode="numeric"
              autoFocus
            />
          </div>
        )}
        <div className="modal-buttons">
          <button
            className="btn btn-confirm"
            disabled={loading}
            onClick={onUpdate}
          >
            {loading ? (
              <Loader2 className="spin" size={16} />
            ) : (
              <Check size={16} />
            )}
            Update
          </button>
          <button
            className="btn btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            <X size={16} /> Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotoPriceModal;